import React from 'react';
import pt from 'prop-types';
import { SearchBar, Stack } from '@metarouter-private/mr-mui';

const INPUT_PROPS = { disableUnderline: true };
const HTML_INPUT_PROPS = { 'aria-label': 'Search organizations', 'data-test-id': 'OrgSwitcherSearch' };

export default function OrgSearch({ search, setSearch }) {
  return (
    <Stack paddingX={2}>
      <SearchBar
        name="orgSearch"
        placeholder="Search organizations"
        variant="standard"
        autoFocus
        value={search}
        onChange={event => setSearch(event.target.value)}
        InputProps={INPUT_PROPS}
        inputProps={HTML_INPUT_PROPS}
      />
    </Stack>
  );
}

OrgSearch.propTypes = {
  search: pt.string.isRequired,
  setSearch: pt.func.isRequired,
};
